export default __webpack_public_path__ + "static/media/lamps001.05761c1c.jpeg";